// Internal modules
import { dispatchFormAction } from '@/store';
import { logBlurOrFocusEvent } from '../../../Form/utils';
import { conditionallyClearCardConversion } from '../CurrencyConversion';
import { conditionallyFetchConversionData } from '@/lib/graphql/operations/currencyConversion';

const blurHandler = e => {
  e.persist();
  logBlurOrFocusEvent(e);

  // For a blur event e.relatedTarget will be the element that is
  // going to be focused once the current field that is being blurred
  // is no longer the active element
  const nextFocusedEl = e.relatedTarget;
  conditionallyFetchConversionData(nextFocusedEl);
};

// cardType needs a special handler as it is part of cardNumber in
// data store - cardNumber.cardType = { type: '', subType: '' }
const cardTypeChangeHandler = (e, newValue) => {
  // If the card type changes and we have conversion data that we are
  // displaying, we need to clear it since the card type affects conversion.
  // Updated data will be fetched on blur of the card type dropdown.
  conditionallyClearCardConversion();

  // field is preset to cardNumber as cardType is part of it
  const field = 'cardNumber';
  const payload = { cardType: newValue };

  dispatchFormAction({ field, payload });
};

export { blurHandler, cardTypeChangeHandler };
